import { object } from 'common/helpers'


export const initialState = {
  config: {},
  isInitialized: false,
  isFetching: false,
  isFetched: false,
  plugins: {},
  auth: {},
}

export const setInitialized = (state, payload) => ({ ...state, isInitialized: payload })

export const setFetching = (state, payload) => ({ ...state, isFetching: payload, isFetched: !payload })

export const setConfig = (state, payload) => ({ ...state, config: payload })

/**
 *
 * @param state
 * @param payload
 * @param payload.name {string} - plugin name
 * @param payload.data {object}
 */
export const updatePlugin = (state, { name, data }) =>
  object.setIn(state, [ 'plugins', name ], data)

/**
 *
 * @param state
 * @param payload {string} - plugin name
 */
export const removePlugin = (state, payload) =>
  object.update(state, 'plugins', (plugins) => {
    delete plugins[payload]
    return plugins
  })

export const setAuth = (state, payload) => ({ ...state, auth: payload })
